import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// Component
import { LayoutComponent } from './layouts/layout.component';
import { AlicroGuard } from './core/guards/alicro.guard';

const routes: Routes = [
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AlicroGuard] },
  { path: 'auth', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  { path: 'pages', loadChildren: () => import('./extraspages/extraspages.module').then(m => m.ExtraspagesModule), canActivate: [AlicroGuard] },
  { path: 'revisar-documentos', loadChildren: () => import('./revisar-documentos/revisar-documentos.module').then(m => m.RevisarDocumentosModule) },
  { path: 'diligenciar', loadChildren: () => import('./pages/perfil-sociodemografico/diligenciar/diligenciar.module').then(m => m.DiligenciarModule) },
  { path: 'completar-perfil', loadChildren: () => import('./pages/perfil-sociodemografico/completar-perfil/completar-perfil.module').then(m => m.CompletarPerfilModule) },
  { path: 'encuesta-publica/:token', loadChildren: () => import('./pages/encuesta-publica/encuesta-publica.module').then(m => m.EncuestaPublicaModule) },
  { path: 'comites/firmar-acta/:id', loadChildren: () => import('./pages/comites/firmar-acta/firmar-acta.module').then(m => m.FirmarActaModule) },
  { path: 'comites/postular/:comiteId/:personaPerfilVersionId', loadChildren: () => import('./pages/comites/postular/postular.module').then(m => m.PostularModule) },
  { path: 'comites/votar/:comiteId/:votanteId/:candidatoId', loadChildren: () => import('./pages/comites/votar/votar.module').then(m => m.VotarModule) },
  { path: 'comites/votar/:comiteId/:votanteId', loadChildren: () => import('./pages/comites/votar/votar.module').then(m => m.VotarModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
